import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Action, AppState, RouterHookParams } from '../../types';
import Router from '../components/router';
import { onEnterRouteAction } from '../redux/router-actions';

export const mapDispatchToProps = (dispatch: Dispatch<Action<{}>>) => {
  return {
    onEnterRoute: (params: RouterHookParams) => {
      dispatch(onEnterRouteAction(params));
    },
  };
};

export const mapStateToProps = (state: AppState) => {
  return {
    loggedIn: state.auth.loggedIn,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Router);
